var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.137 15.039H23.863c-4.866 0-8.824 3.959-8.824 8.824v52.273c0 4.865 3.958 8.824 8.824 8.824h52.273c4.866 0 8.824-3.959 8.824-8.824V23.863c0-4.865-3.958-8.824-8.824-8.824Zm-7.238 3v5.034h-5.034v-5.034h5.034Zm-32.763 0v5.034h-5.034v-5.034h5.034Zm-12.272 0h4.238v6.534a1.5 1.5 0 0 0 1.5 1.5h8.034a1.5 1.5 0 0 0 1.5-1.5v-6.534h21.729v6.534a1.5 1.5 0 0 0 1.5 1.5h8.034a1.5 1.5 0 0 0 1.5-1.5v-6.534h4.238a5.83 5.83 0 0 1 5.824 5.824v10.961H18.039V23.863a5.83 5.83 0 0 1 5.824-5.824Zm52.273 63.922H23.863a5.83 5.83 0 0 1-5.824-5.824V37.824h63.922v38.312a5.83 5.83 0 0 1-5.824 5.824Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.826 47.559H56.745a1.5 1.5 0 0 0-1.5 1.5V63.14a1.5 1.5 0 0 0 1.5 1.5h14.081a1.5 1.5 0 0 0 1.5-1.5V49.059a1.5 1.5 0 0 0-1.5-1.5Zm-1.5 14.081H58.245V50.559h11.081V61.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.54816136d73180bd83ecc24dcb688132.svg";
export { ForwardRef as ReactComponent };